"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SELECT_IMAGE_OPTIMIZATION_SETTING = exports.SAVE_FILE_EDIT_FAILED = exports.SAVE_FILE_EDIT_SUCCEEDED = exports.SAVE_FILE_EDIT_ATTEMPTED = exports.FETCH_FILE_FOR_EDITING_SUCCEEDED = exports.FETCH_FILE_FOR_EDITING_FAILED = exports.FETCH_FILE_FOR_EDITING_ATTEMPTED = exports.CLEAR_FILE_FOR_EDITING = exports.ACQUIRE_IMAGE_FAILED = exports.ACQUIRE_IMAGE_SUCCEEDED = exports.ACQUIRE_IMAGE_ATTEMPTED = exports.ADD_FOLDER_SUCCEEDED = exports.SELECT_STOCK_FILE = exports.UPDATE_DETAIL_HEIGHT = exports.SET_FILTER = exports.SELECT_FILE = exports.SEARCH = exports.CLEAR_HISTORY = exports.BACK = exports.SET_PANEL = void 0;
var SET_PANEL = 'SET_PANEL';
exports.SET_PANEL = SET_PANEL;
var BACK = 'BACK';
exports.BACK = BACK;
var CLEAR_HISTORY = 'CLEAR_HISTORY';
exports.CLEAR_HISTORY = CLEAR_HISTORY;
var SEARCH = 'SEARCH';
exports.SEARCH = SEARCH;
var SELECT_FILE = 'SELECT_FILE';
exports.SELECT_FILE = SELECT_FILE;
var SET_FILTER = 'SET_FILTER';
exports.SET_FILTER = SET_FILTER;
var UPDATE_DETAIL_HEIGHT = 'UPDATE_DETAIL_HEIGHT';
exports.UPDATE_DETAIL_HEIGHT = UPDATE_DETAIL_HEIGHT;
var SELECT_STOCK_FILE = 'SELECT_STOCK_FILE';
exports.SELECT_STOCK_FILE = SELECT_STOCK_FILE;
var ADD_FOLDER_SUCCEEDED = 'ADD_FOLDER_SUCCEEDED';
exports.ADD_FOLDER_SUCCEEDED = ADD_FOLDER_SUCCEEDED;
var ACQUIRE_IMAGE_ATTEMPTED = 'ACQUIRE_IMAGE_ATTEMPTED';
exports.ACQUIRE_IMAGE_ATTEMPTED = ACQUIRE_IMAGE_ATTEMPTED;
var ACQUIRE_IMAGE_SUCCEEDED = 'ACQUIRE_IMAGE_SUCCEEDED';
exports.ACQUIRE_IMAGE_SUCCEEDED = ACQUIRE_IMAGE_SUCCEEDED;
var ACQUIRE_IMAGE_FAILED = 'ACQUIRE_IMAGE_FAILED';
exports.ACQUIRE_IMAGE_FAILED = ACQUIRE_IMAGE_FAILED;
var CLEAR_FILE_FOR_EDITING = 'CLEAR_FILE_FOR_EDITING';
exports.CLEAR_FILE_FOR_EDITING = CLEAR_FILE_FOR_EDITING;
var FETCH_FILE_FOR_EDITING_ATTEMPTED = 'FETCH_FILE_FOR_EDITING_ATTEMPTED';
exports.FETCH_FILE_FOR_EDITING_ATTEMPTED = FETCH_FILE_FOR_EDITING_ATTEMPTED;
var FETCH_FILE_FOR_EDITING_FAILED = 'FETCH_FILE_FOR_EDITING_FAILED';
exports.FETCH_FILE_FOR_EDITING_FAILED = FETCH_FILE_FOR_EDITING_FAILED;
var FETCH_FILE_FOR_EDITING_SUCCEEDED = 'FETCH_FILE_FOR_EDITING_SUCCEEDED';
exports.FETCH_FILE_FOR_EDITING_SUCCEEDED = FETCH_FILE_FOR_EDITING_SUCCEEDED;
var SAVE_FILE_EDIT_ATTEMPTED = 'SAVE_FILE_EDIT_ATTEMPTED';
exports.SAVE_FILE_EDIT_ATTEMPTED = SAVE_FILE_EDIT_ATTEMPTED;
var SAVE_FILE_EDIT_SUCCEEDED = 'SAVE_FILE_EDIT_SUCCEEDED';
exports.SAVE_FILE_EDIT_SUCCEEDED = SAVE_FILE_EDIT_SUCCEEDED;
var SAVE_FILE_EDIT_FAILED = 'SAVE_FILE_EDIT_FAILED';
exports.SAVE_FILE_EDIT_FAILED = SAVE_FILE_EDIT_FAILED;
var SELECT_IMAGE_OPTIMIZATION_SETTING = 'SELECT_IMAGE_OPTIMIZATION_SETTING';
exports.SELECT_IMAGE_OPTIMIZATION_SETTING = SELECT_IMAGE_OPTIMIZATION_SETTING;